// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Lokasyon Seçimi',
  country: 'Ülke',
  searchCountry: 'Ülke ara...',
  state: 'İl / Eyalet',
  found: 'bulundu',
  selectState: 'İl / Eyalet seçin',
  selectedLocation: 'Seçilen Lokasyon'
};
